import { combineReducers } from '@ngrx/store';

import * as fromPresets from './live-presets.reducer';
import * as fromBuiltInInsights from './live-builtIn-insights.reducer';
import * as fromCameras from './live-cameras.reducer';
import * as fromMediaFilesView from './live-media-files-view.reducer';
import * as fromPinnedCameras from './live-pinned-cameras.reducer';
import * as fromCustomInsights from './live-custom-insights.reducer';
import * as fromGalleryView from './live-gallery-view.reducer';
import * as fromMediaFiles from './live-media-files.reducer';
import * as fromFilters from './live-filters.reducer';
import * as fromCameraView from './live-camera-view.reducer';
import * as fromSpatial from './live-spatial.reducer';
import * as fromSegments from './live-segments.reducer';

export const liveFeatureKey = 'live';
export interface IState {
  presets: fromPresets.IState;
  builtInInsights: fromBuiltInInsights.IState;
  cameras: fromCameras.IState;
  pinnedCameras: fromPinnedCameras.IPinnedState;
  customInsights: fromCustomInsights.State;
  galleryView: fromGalleryView.State;
  mediaFiles: fromMediaFiles.IState;
  filters: fromFilters.IState;
  cameraView: fromCameraView.State;
  spatial: fromSpatial.ISpatialDrawingState;
  segments: fromSegments.IState;
  mediaFilesView: fromMediaFilesView.IMediaFilesViewState;
}

export const reducer = combineReducers<IState>({
  presets: fromPresets.reducer,
  builtInInsights: fromBuiltInInsights.reducer,
  cameras: fromCameras.reducer,
  pinnedCameras: fromPinnedCameras.reducer,
  customInsights: fromCustomInsights.reducer,
  galleryView: fromGalleryView.reducer,
  mediaFiles: fromMediaFiles.reducer,
  filters: fromFilters.reducer,
  cameraView: fromCameraView.reducer,
  spatial: fromSpatial.spatialReducer,
  segments: fromSegments.reducer,
  mediaFilesView: fromMediaFilesView.reducer
});
